import(/* webpackMode: "eager" */ "/vercel/path0/src/app/news/page.tsx");
